export enum PreviewEmployeesModalColumn {
  birth_date = "birth_date",
}
